export default __webpack_public_path__ + "static/media/rmall-project-1.5442611c.png";